import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '热门漫画', path: '/category/romance' },
    { label: '最新上架', path: '/category/fantasy' },
    { label: '排行榜', path: '/category/action' },
    { label: '关于我们', path: '/about' },
  ],
  漫画分类: [
    { label: '恋爱漫画', path: '/category/romance' },
    { label: '奇幻漫画', path: '/category/fantasy' },
    { label: '动作漫画', path: '/category/action' },
    { label: '悬疑漫画', path: '/category/suspense' },
  ],
  关于我们: [
    { label: '品牌故事', path: '/about' },
    { label: '联系我们', path: '/about' },
    { label: '用户协议', path: '/' },
    { label: '隐私政策', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div>
            <Link to="/" className="inline-block cursor-pointer mb-4">
              <span className="font-heading text-2xl text-primary-400">韩漫屋</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫屋是免费韩漫与漫画大全的聚集地，
              <br />
              提供海量在线漫画资源，持续为您
              <br />
              推荐好看的韩国漫画作品。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-400 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-200 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫屋 pedionline.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}